<div class="alert alert-warning" role="alert">
  お探しのページは見つかりませんでした。
</div>
<div>
  <a [routerLink]="" (click)="jumpPrevPage()">戻る</a>
</div>
